(async () => {
    const { Core } = await importModule('Core');
    const { $hide, $show, $toggleDisplay } = await importModule('Utils');

    customElements.define('product-dynamic-checkout', class extends Core {
        subscriptions = {
            'buyWith:change':  '_handleBuyWith'
        }
        buyWithProductsCount = 0;

        render() {
            this._rerenderPaymentButton();
            this.subscribe('buyWith:change');
        }

        _rerenderPaymentButton() {
            if (window.Shopify?.PaymentButton?.init) {
              window.Shopify.PaymentButton.init();
            }
        };

        _handleBuyWith({ selected }) {
            this.buyWithProductsCount += selected ? 1 : -1;
            return $toggleDisplay(this, !this.buyWithProductsCount);
        }
    })
})();